var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.324 3.933 1.62 1.38a1.5 1.5 0 0 0 .972.358h2.117a.5.5 0 0 1 .492.415l.372 2.141a1.5 1.5 0 0 0 .506.886l1.643 1.4a.5.5 0 0 1 .11.627l-1.076 1.894a1.5 1.5 0 0 0-.174.998l.373 2.153a.5.5 0 0 1-.32.554l-2.002.74a1.5 1.5 0 0 0-.783.666l-1.063 1.87a.5.5 0 0 1-.608.222l-1.983-.733a1.5 1.5 0 0 0-1.04 0l-1.983.733a.5.5 0 0 1-.608-.222l-1.063-1.87a1.5 1.5 0 0 0-.784-.666l-2.002-.74a.5.5 0 0 1-.32-.554l.374-2.153a1.5 1.5 0 0 0-.174-.998L3.844 11.14a.5.5 0 0 1 .11-.628l1.643-1.4a1.5 1.5 0 0 0 .506-.885l.372-2.141a.5.5 0 0 1 .492-.415h2.117a1.5 1.5 0 0 0 .973-.358l1.618-1.38a.5.5 0 0 1 .649 0Z",
    stroke: "#222",
    className: "stroke",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShine);
export default __webpack_public_path__ + "static/media/shine.dae56a5e.svg";
export { ForwardRef as ReactComponent };